module.exports = __webpack_public_path__ + "img/no_win.0317683c.png";